import { useEffect, useState } from "react";
import { FaArrowAltCircleUp } from "react-icons/fa";

function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);

  // Track scroll position and toggle visibility
  useEffect(() => {
    const handleScroll = () => {
      // Show button when scrolled past 100px
      if (window.scrollY > window.innerHeight) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // Scroll to top handler
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <div>
      {isVisible && (
        <div
          className="flex items-center justify-center w-16 h-16 fixed bottom-2 right-2 text-primeColor  cursor-pointer "
          onClick={scrollToTop}
        >
          <FaArrowAltCircleUp size={35} />
        </div>
      )}
    </div>
  );
}

export default ScrollToTop;
